import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../../../data/api';
import { useAtomValue } from 'jotai';
import { userInfoAtom } from '../../../../data/atoms/utilsAtoms';
import PdfPreview from '../../../components/PdfPreview';
import PdfViewer from '../../../components/PdfView';
import MuxVideoPlayer from '../../../../Pages/VideoPlayer/components/MuxVideoPlayer';
import { PlayerPageWrapper } from '../../../../Pages/VideoPlayer/PlayerPage';
import CommonContent from '../../../components/CommonContent';
import Toast from '../../../../utils/toastManager';
import TRC_FILE_TYPE from '../../../constants/trcFileType';
import TRCVideoDescription from '@/TRC/pages/Videos/components/description';

const TRCResource = () => {
	const [content, setContent] = useState();
	const userData = useAtomValue(userInfoAtom);
	const [pdfView, setPdfView] = useState(false);

	const { id } = useParams();
	const fetchContentDataById = async () => {
		try {
			const response = await api.getContentById(id);
			setContent(response?.data);
		} catch (err) {
			Toast.error(err.message || 'Something went wrong');
		}
	};

	useEffect(() => {
		fetchContentDataById();
	}, [id]);

	return (
		<div className="d-flex flex-column gap-2" style={{ height: '40vh' }}>
			{content?.fileType === TRC_FILE_TYPE.VIDEO ? (
				<div className="video-container">
					<MuxVideoPlayer
						CustomWrapper={PlayerPageWrapper}
						videoLink={content?.fileUrl}
						videoTitle={content?.title}
						poster={content?.thumbnailLink}
						storyboardToken={content?.contentStoryboardToken}
						userId={userData?.user?._id}
						videoId={content?._id}
						videoCategory="TRC Resource"
						userEmail={userData?.user?.email}
					/>
					<TRCVideoDescription selectedVideo={content} />
				</div>
			) : (
				<>
					{pdfView ? (
						<>
							<div style={{ backgroundColor: '#313135', padding: '0 4rem' }}>
								<PdfViewer fileUrl={content?.fileUrl} onClose={() => setPdfView(false)} />
							</div>
							<div style={{ padding: "1rem" }} >
								<TRCVideoDescription selectedVideo={content} />
							</div>
						</>
					) : (
						<PdfPreview content={content} setPdfView={setPdfView} />
					)}
				</>
			)}
			<CommonContent type={content?.fileType} content={content} />
		</div>
	);
};

export default TRCResource;
